import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useUIStore } from '@/stores/uiStore';

export function ToastContainer() {
  const notifications = useUIStore((state) => state.notifications);
  const removeNotification = useUIStore((state) => state.removeNotification);

  const current = notifications[0];

  if (!current) {
    return null;
  }

  const handleClose = (_event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') return;
    removeNotification(current.id);
  };

  const alertContent = current.message
    ? `${current.title}: ${current.message}`
    : current.title;

  return (
    <Snackbar
      open
      autoHideDuration={current.duration}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    >
      <Alert
        onClose={handleClose}
        severity={current.type}
        variant="filled"
        sx={{ width: '100%' }}
      >
        {alertContent}
      </Alert>
    </Snackbar>
  );
}
